import { Card, Heading, Inline, Stack, Text, textVariants } from '@etg/wings';
import { useDateFormat, useTranslation } from '@eti/providers';
import { date as dateUtil } from '@eti/utils';
import { CarrierLogo } from '@eti/components';
import { css } from '@eti/styles';
import { getBoundTitle, getBoundType } from '../../../widgets/trip-details/utils/format';
import { getBoundInfo } from '../utils';
import type { TripType } from '../models';

const carrierLogoStyles = css`
  height: 20px;
  width: auto;
`;

const getTitle = (index: number) => {
  return getBoundTitle(getBoundType(index), false);
};

interface OriginalTripProps {
  originalTrip: TripType;
}

const OriginalTrip = ({ originalTrip }: OriginalTripProps) => {
  const { shortWeekday } = useDateFormat();
  const { t } = useTranslation();

  return (
    <Card data-testid="changeTrip-original-trip">
      <Stack>
        <Heading level={2}>{t('ChangeTrip.OriginalTrip.Title')}</Heading>
        {originalTrip.bounds.map((bound, index) => {
          const boundInfo = getBoundInfo(bound.segments);

          return (
            <Stack key={`route-${boundInfo.origin}-${boundInfo.destination}`}>
              <Heading level={3}>{t(getTitle(index))}</Heading>
              <Inline>
                {boundInfo.marketingCarrierName && (
                  <CarrierLogo
                    className={carrierLogoStyles}
                    id={boundInfo.marketingCarrierCode}
                    imageAlt={boundInfo.marketingCarrierName}
                  />
                )}
                <Stack spacing={8}>
                  <Text data-testid={`${index}-origin-destination`} variant={textVariants._16}>
                    <bdi>
                      {boundInfo.origin} ({boundInfo.departureCode}) - {boundInfo.destination} (
                      {boundInfo.arrivalCode})
                    </bdi>
                  </Text>
                  <Text data-testid={`${index}-departure-arrival`}>
                    <bdi>
                      {dateUtil.format(boundInfo.departuredAt, shortWeekday)},{' '}
                      {dateUtil.format(boundInfo.departuredAt, 'HH:mm')} -{' '}
                      {dateUtil.format(boundInfo.arrivedAt, shortWeekday)},{' '}
                      {dateUtil.format(boundInfo.arrivedAt, 'HH:mm')}
                    </bdi>
                  </Text>
                </Stack>
              </Inline>
            </Stack>
          );
        })}
      </Stack>
    </Card>
  );
};

export default OriginalTrip;
